<div class="d-flex flex-wrap" mat-dialog-title style="margin: unset; padding: 1px 10px 1px 28px"
  [nbSpinner]="isLoading">
  <button mat-button color="primary" (click)="saveData()" [disabled]="!frmUser.valid || isLoading">
    <mat-icon fontSet=" material-icons-outlined">save</mat-icon>
    <span *ngIf="!isLoading">Save</span>
    <span *ngIf="isLoading">Saving...</span>
  </button>
  <button mat-button color="primary" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>Cancel
  </button>
  <button mat-icon-button aria-label="Close the dialog" (click)="closeDialog()" class="ml-auto">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="frmUser" class="form-container" (ngSubmit)="saveData()">
    <div class="row" [style.display]="action == 3 ? 'block' : 'none'">
      <div class="pt-3 col-12 d-flex justify-content-center">
        <app-headshot [userModel]="userModel" #headshot></app-headshot>
      </div>
    </div>
    <div class="bg-white px-3 mb-3 rounded">
      <mat-form-field appearance="standard">
        <mat-label>User Name</mat-label>
        <input matInput formControlName="userName" autocomplete="off" required [readonly]="action == 1 || action == 3"
          trim="blur" />
        <mat-error *ngIf="
            frmUser.controls.userName.errors &&
            (frmUser.controls.userName.dirty ||
              frmUser.controls.userName.touched)
          ">
          {{ frmUser.controls.userName["errorMessage"] }}</mat-error>
        <mat-hint *ngIf="!isChangePassword && action != 0" align="end">
          <a href="javascrip:void(0)" class="text-primary" (click)="confirmChangePassword()">
            Change Password
          </a>
        </mat-hint>
      </mat-form-field>
      <div *ngIf="action == 0">
        <div class="alert alert-primary" role="alert">
          If password and confirm password are empty, the system will generate new password.
        </div>
      </div>

      <div *ngIf="action == 1">
        <nb-toggle formControlName="isActive" status="success">Active</nb-toggle>
      </div>

      <ng-container *ngIf="isChangePassword || action == 0">
        <mat-form-field appearance="standard">
          <mat-label *ngIf="action == 1 || action == 3">New Password</mat-label>
          <mat-label *ngIf="action == 0">Password</mat-label>
          <input *ngIf="action == 1 || action == 3" matInput type="password" formControlName="password"
            autocomplete="off" trim="blur" />
          <input *ngIf="action == 0" matInput type="password" formControlName="password" autocomplete="off"
            trim="blur" />
          <mat-error *ngIf="
              frmUser.controls.password.errors &&
              (frmUser.controls.password.dirty ||
                frmUser.controls.password.touched)
            ">
            {{ frmUser.controls.password["errorMessage"] }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard">
          <mat-label *ngIf="action == 1 || action == 3">Confirm New Password</mat-label>
          <mat-label *ngIf="action == 0">Confirm Password</mat-label>
          <input *ngIf="action == 1 || action == 3" matInput type="password" formControlName="confirmPassword"
            autocomplete="off" trim="blur" />
          <input *ngIf="action == 0" matInput type="password" formControlName="confirmPassword" autocomplete="off"
            trim="blur" />
          <mat-error *ngIf="
                frmUser.controls.confirmPassword.errors &&
                (frmUser.controls.confirmPassword.dirty ||
                  frmUser.controls.confirmPassword.touched)
              ">
            {{ frmUser.controls.confirmPassword["errorMessage"] }}</mat-error>
        </mat-form-field>
      </ng-container>

      <mat-form-field appearance="standard">
        <mat-label>Email</mat-label>
        <input matInput id="email" type="email" formControlName="email" autocomplete="off" required trim="blur" />
        <mat-error *ngIf="
              frmUser.controls.email.errors &&
              (frmUser.controls.email.dirty || frmUser.controls.email.touched)
            ">
          {{ frmUser.controls.email["errorMessage"] }}</mat-error>
      </mat-form-field>

      <!-- Phone Numbers Section -->
      <div class="phone-numbers-section">
        <div class="d-flex align-items-center">
          <mat-label style="color: #666666; font-size: 14px;">Phone Numbers</mat-label>
        </div>

        <!-- Phone Numbers Skeleton Loading -->
        <div *ngIf="isLoadingProfile" class="phone-skeleton-container">
          <ngx-skeleton-loader count="1" [theme]="{'border-radius': '0', height: '40px', 'margin-bottom': '8px'}">
          </ngx-skeleton-loader>
        </div>

        <!-- Real Phone Numbers Form -->
        <div formArrayName="phoneNumbers" *ngIf="!isLoadingProfile" class="p-2 mt-2" style="border: 1px solid #777">
          <div *ngFor="let phoneGroup of phoneNumbersFormArray.controls; let i = index; trackBy: trackByPhoneNumber"
            [formGroupName]="i" class="phone-number-row d-flex align-items-center mb-2">

            <!-- Primary Contact Icon -->
            <button type="button" mat-icon-button (click)="setPrimaryContact(i)" class="primary-btn"
              matTooltip="{{phoneGroup.get('isPrimary')?.value ? 'Primary Contact' : 'Set as Primary'}}"
              [class.primary-active]="phoneGroup.get('isPrimary')?.value">
              <mat-icon [style.color]="phoneGroup.get('isPrimary')?.value ? '#ffd700' : '#ccc'">
                {{phoneGroup.get('isPrimary')?.value ? 'star' : 'star_border'}}
              </mat-icon>
            </button>

            <mat-form-field appearance="standard" class="flex-grow-1 mr-2">
              <mat-label>Phone Number {{i + 1}} {{phoneGroup.get('isPrimary')?.value ? '(Primary)' : ''}}</mat-label>
              <input matInput type="tel" formControlName="phoneNumber" autocomplete="off" trim="blur" />
              <mat-error
                *ngIf="phoneGroup.get('phoneNumber').errors && (phoneGroup.get('phoneNumber').dirty || phoneGroup.get('phoneNumber').touched)">
                {{ phoneGroup.get('phoneNumber')["errorMessage"] }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="standard" class="flex-grow-1 mr-2">
              <mat-label>Outbound Trunk</mat-label>
              <input matInput type="text" formControlName="outboundTrunk" autocomplete="off" trim="blur" />
            </mat-form-field>

            <button type="button" mat-icon-button color="warn" (click)="removePhoneNumber(i)"
              [disabled]="phoneNumbersFormArray.length <= 1" matTooltip="Remove Phone Number"
              style="width: 32px; height: 32px;">
              <mat-icon style="font-size: 24px;">delete</mat-icon>
            </button>
          </div>
          <div class="d-flex justify-content-end">
            <a href="javascript:void(0)" class="fs-7 text-primary" (click)="addPhoneNumber()" *ngIf="!isLoadingProfile">
              Add More Phone Number
            </a>
          </div>
        </div>
      </div>

      <mat-form-field appearance="standard">
        <mat-label>Outbound Caller Id</mat-label>
        <input matInput type="text" formControlName="outboundCallerId" autocomplete="off" trim="blur"
          [readonly]="readonlyCaller" />
        <mat-error
          *ngIf="frmUser.controls.outboundCallerId.errors && (frmUser.controls.outboundCallerId.dirty || frmUser.controls.outboundCallerId.touched)">
          {{ frmUser.controls.outboundCallerId["errorMessage"] }}</mat-error>
      </mat-form-field>

      <a href="javascript:void(0)" class="fs-7 text-primary" (click)="isShowCallFlowData = !isShowCallFlowData"
        *ngIf="!isShowCallFlowData">
        Show Callflow Configuration
      </a>

      <div class="row" *ngIf="isShowCallFlowData">
        <mat-form-field appearance="none" class="col-12">
          <mat-label style="color: #666666; font-size: 14px; margin-bottom: 8px; display: block;">Callflow Mobile Phone
            Numbers</mat-label>
          <mat-chip-list #chipList class="callflow-chip-list">
            <mat-chip *ngFor="let phone of callFlowPhoneNumbers; let i = index"
              style="background-color: #307abd; color: white !important;" [removable]="true"
              (removed)="removeCallFlowPhone(i)">
              {{ phone }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="Use ';' or a space to separate multiple numbers" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addCallFlowPhone($event)" type="tel" autocomplete="off"
              class="callflow-chip-input" />
          </mat-chip-list>
          <mat-error
            *ngIf="frmUser.controls.callFlowMobilePhoneNumber.errors && (frmUser.controls.callFlowMobilePhoneNumber.dirty || frmUser.controls.callFlowMobilePhoneNumber.touched)">
            {{ frmUser.controls.callFlowMobilePhoneNumber["errorMessage"] }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" class="col-12">
          <mat-label>Callflow Language Used</mat-label>
          <mat-select formControlName="callFlowLanguage">
            <!-- Toggle button for showing all languages - without value so it won't be selected -->
            <!-- <mat-option (click)="toggleLanguageView($event)" class="language-toggle-option" [disabled]="true">
              <div class="language-toggle-content" (click)="toggleLanguageView($event)">
                <mat-icon>{{ showAllLanguages ? 'expand_less' : 'expand_more' }}</mat-icon>
                <span>{{ showAllLanguages ? 'Show Popular Languages' : 'Show All Languages' }}</span>
              </div>
            </mat-option> -->

            <!-- Search input -->
            <ngx-mat-select-search [formControl]="languageSearchCtrl" [noEntriesFoundLabel]="'Not Found...'"
              [placeholderLabel]="'Search'">
            </ngx-mat-select-search>
            <mat-option *ngFor="let language of getDisplayLanguages()" [value]="language.code">
              {{ getLanguageDisplay(language) }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="frmUser.controls.callFlowLanguage.errors && (frmUser.controls.callFlowLanguage.dirty || frmUser.controls.callFlowLanguage.touched)">
            {{ frmUser.controls.callFlowLanguage["errorMessage"] }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" class="col-12">
          <mat-label>Experience Level of Voicebots</mat-label>
          <mat-select formControlName="experienceLevel">
            <mat-option value="New">New</mat-option>
            <mat-option value="Junior">Junior</mat-option>
            <mat-option value="Senior">Senior</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field appearance="standard">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="firstName" autocomplete="off" required trim="blur" />
        <mat-error *ngIf="
              frmUser.controls.firstName.errors &&
              (frmUser.controls.firstName.dirty ||
                frmUser.controls.firstName.touched)
            ">
          {{ frmUser.controls.firstName["errorMessage"] }}</mat-error>
      </mat-form-field>


      <mat-form-field appearance="standard">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="lastName" autocomplete="off" required trim="blur" />
        <mat-error *ngIf="
              frmUser.controls.lastName.errors &&
              (frmUser.controls.lastName.dirty ||
                frmUser.controls.lastName.touched)
            ">
          {{ frmUser.controls.lastName["errorMessage"] }}</mat-error>
      </mat-form-field>

      <ng-container>
        <mat-form-field appearance="standard" style="padding-top:0px">
          <mat-label>Manager</mat-label>
          <mat-select formControlName="managerId" placeholder="There is no user to select yet">
            <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
            <mat-option>
              <ngx-mat-select-search [formControl]="SelectSearchInput" [noEntriesFoundLabel]="'Not Found...'"
                [searching]="isLoading" [placeholderLabel]="'Search'">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null" class="start center">Unassign</mat-option>
            <mat-option *ngFor="let item of filteredUsers | async" [value]="item.id">
              {{item.userName}}
            </mat-option>
            <mat-error
              *ngIf="frmUser.controls.managerId.errors && (frmUser.controls.managerId.dirty || frmUser.controls.managerId.touched)">
              {{frmUser.controls.managerId['errorMessage']}}
            </mat-error>
          </mat-select>
          <nb-spinner *ngIf="listUser.length == 0" matSuffix size="small"></nb-spinner>
        </mat-form-field>
      </ng-container>

      <!-- Timezone Skeleton Loading -->
      <div *ngIf="isLoadingTimezone">
        <ngx-skeleton-loader count="1" [theme]="{'border-radius': '0', height: '56px', 'margin-bottom': '8px'}">
        </ngx-skeleton-loader>
      </div>

      <!-- Timezone Field -->
      <mat-form-field appearance="standard" *ngIf="!isLoadingTimezone">
        <mat-label>Timezone</mat-label>
        <mat-select formControlName="timezone" #singleSelect (selectionChange)="onTimezoneChange($event.value)">
          <mat-select-trigger>
            <div class="multiline-mat-option">
              <div>{{selectedTimezone?.text}}</div>
              <div class="text-secondary">{{selectedTimezone?.value}}</div>
            </div>
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search [formControl]="timezoneSearchCtrl" [noEntriesFoundLabel]="'Not Found...'"
              [placeholderLabel]="'Search timezone...'">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let item of filteredTimezones | async" [value]="item.value"
            [matTooltip]="item.text" matTooltipPosition="left" class="multiline-mat-option">
            <div>
              <div>{{item.text}}</div>
              <div class="text-secondary">{{item.value}}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div style="max-width: 50%;" *ngIf="action != 3">
        <mat-form-field appearance="standard">
          <mat-label>Role</mat-label>
          <mat-select formControlName="roles" required multiple>
            <mat-option *ngFor="let item of listRoles" [value]="item.id | lowercase">
              {{ item.displayName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="
              frmUser.controls.roles.errors &&
              (frmUser.controls.roles.dirty || frmUser.controls.roles.touched)
            ">
            {{ frmUser.controls.roles["errorMessage"] }}
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="!isCustomer" class="pt-3">
        <div style="height: fit-content">
          <mat-label style="color: #666666">Job Title</mat-label>
          <quill-editor [modules]="editorOptions" placeholder="Job title" formControlName="jobTitle">
          </quill-editor>
        </div>
        <button type="submit" style="display: none"></button>
      </div>

      <div class="apitoken-container">
        <mat-form-field appearance="standard">
          <mat-label>API Token</mat-label>
          <input class="w-100" matInput type="text" trim="blur" [value]="maskedApiToken" readonly />
        </mat-form-field>
        <button mat-raised-button color="primary" [ngStyle]="{'width': maskedApiToken ? '20%' : '18%'}"
          (click)="generateToken($event)" [disabled]="isLoadingApiToken">
          <span *ngIf="!isLoadingApiToken">{{maskedApiToken ? "Regenerate" : "Generate"}}</span>
          <span *ngIf="isLoadingApiToken">
            <nb-spinner size="tiny" class="mr-1"></nb-spinner>
            Generating...
          </span>
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ng-template #textConfirmGenerate>
  <div class="text-confirm-generate">
    <span>{{"Are you sure you want to generate new API Token?"}}</span>
    <span>{{"The old API Token will be disabled, and all the applications connected to it may not work
      properly"}}</span>
  </div>
</ng-template>

<ng-template #copyDialogContainer>
  <div class="copy-dialog-container">
    <div style="font-size: 16px;">Make sure to copy your token now as you will not be able to see it again.</div>
    <div class="token-container">
      <mat-card class="token-placeholder">
        <mat-card-content style="font-size: 15px;">{{fullApiToken}}</mat-card-content>
      </mat-card>
      <button class="copy-button" *ngIf="!isCopy;else copied" (click)="onCopyClick()"
        matTooltip="Click to copy this token">
        <nb-icon style="color: #8c959f;" nbPrefix icon="copy-outline" pack="eva"></nb-icon>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #copied>
  <button class="copy-button" matTooltip="Copied!!!" style="cursor: default">
    <nb-icon style="color: green;" nbPrefix icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
  </button>
</ng-template>